import moment from 'moment';

export function isInkindPageNew(createdUTC: moment.Moment): boolean {
  return createdUTC.isAfter(moment.utc().subtract(12, 'hours'));
}
